import { useQuery } from '@apollo/client';
import { GET_USER_FAVORITES } from '../api/queries';
import { GetUserDataQuery } from '../api/types';

interface UseUserFavoritesProps {
  skip?: boolean;
  noCache?: boolean;
}

export const useUserFavorites = ({
  skip = false,
  noCache,
}: UseUserFavoritesProps = {}) => {
  const { data, refetch, loading } = useQuery<GetUserDataQuery>(
    GET_USER_FAVORITES,
    {
      skip,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: noCache ? 'network-only' : 'cache-first',
      errorPolicy: 'all',
    }
  );
  const latestBookmark = data?.currentUser?.bookmarks?.nodes?.at(0) ?? null;

  return {
    loading,
    refetch,
    latestBookmark,
    bookmarks: data?.currentUser?.bookmarks?.nodes ?? [],
    bookmarksTotalCount: data?.currentUser?.bookmarks?.totalCount,
    bookmarkedCategories: data?.currentUser?.bookmarkedCategories ?? [],
    bookmarkCollections: data?.currentUser?.bookmarkCollections?.nodes ?? [],
  };
};
